import { Investment_IdeaCategory } from '../../__generated__/globalTypes';

const isCrypto = (category: Investment_IdeaCategory | undefined): boolean =>
  category === Investment_IdeaCategory.CRYPTO;

export { isCrypto };
